import { easyPost } from './request';

export const getTupleList = easyPost('/trade/spot/getInstruments', {
  // mockData: {
  //   code: 0,
  //   data: {
  //     currencyList: [
  //       {
  //         currency: 'BTC',
  //         instrumentId: 'BTC-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'ETH',
  //         instrumentId: 'ETH-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'LTC',
  //         instrumentId: 'LTC-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'OKB',
  //         instrumentId: 'OKB-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'ETC',
  //         instrumentId: 'ETC-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'BCH',
  //         instrumentId: 'BCH-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'EOS',
  //         instrumentId: 'EOS-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'XRP',
  //         instrumentId: 'XRP-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'TRX',
  //         instrumentId: 'TRX-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //       {
  //         currency: 'BSV',
  //         instrumentId: 'BSV-USDT',
  //         quoteCurrency: 'USDT',
  //       },
  //     ],
  //   },
  // },
});

export const placeOrder = easyPost('/trade/spot/orders', {});

export const cancelAll = easyPost('/trade/spot/cancel_orders', {});

export const getDelegateList = easyPost('trade/spot/getDelegateList', {
  mockData: {
    code: 0,
    data: {},
  },
});
